// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1-SXK","inputWrap":"CustomTip_inputWrap__110WO"};